import { lazy } from 'react';
import { Route } from 'react-router-dom';

// 审批详情
const InspectionApproval = lazy(() =>
  import(/* webpackChunkName: "InspectionApproval" */ 'src/views/Inspection/Approval')
);
// 审批x详情
const InspectionDetail = lazy(() =>
  import(/* webpackChunkName: "InspectionDetail" */ 'src/views/Inspection/Detail')
);
const InspectionRouter = {
  '/Inspection/Approval': InspectionApproval,
  '/Inspection/Detail': InspectionDetail
};

export default function InspectionSafetyRoute() {
  // 获取 InspectionRouter 对象的所有键（即路由路径）
  const keys = Object.keys(InspectionRouter);
  const routeArr = keys.map(key => {
    const Components = InspectionRouter[key];
    return <Route key={key} path={key} element={<Components />} />;
  });
  return routeArr;
}
